export const STATUTORY_FIELDS = [
  { key: 'epf_employee', label: 'EPF (Employee)' },
  { key: 'epf_employer', label: 'EPF (Employer)' },
  { key: 'socso_employee', label: 'SOCSO (Employee)' },
  { key: 'socso_employer', label: 'SOCSO (Employer)' },
  { key: 'eis_employee', label: 'EIS (Employee)' },
  { key: 'eis_employer', label: 'EIS (Employer)' },
  { key: 'pcb_tax', label: 'PCB / Tax' },
];

export const EARNING_FIELDS = [
  { key: 'basic_salary', label: 'Basic Salary', profile: true },
  { key: 'transport_allowance', label: 'Transport Allowance', profile: true },
  { key: 'meal_allowance', label: 'Meal Allowance', profile: true },
  { key: 'housing_allowance', label: 'Housing Allowance', profile: true },
  { key: 'other_allowance', label: 'Other Allowance', profile: true },
  { key: 'overtime', label: 'Overtime' },
  { key: 'bonus', label: 'Bonus / Incentive' },
  { key: 'claims_reimbursement', label: 'Claims Reimbursement (non-taxable)' },
];

export const DEDUCTION_FIELDS = [
  { key: 'loan_deduction', label: 'Loan Deduction', profile: true },
  { key: 'other_deductions', label: 'Other Deductions', profile: true },
];

const ALLOWANCE_KEYS = ['transport_allowance', 'meal_allowance', 'housing_allowance', 'other_allowance'];

// Mirrors backend payroll_extras._current_components
export function currentComponents(slip) {
  const eb = slip?.earnings_breakdown || {};
  const db = slip?.deductions_breakdown || {};
  const v = { basic_salary: Number(slip?.basic_salary || 0) };
  if (ALLOWANCE_KEYS.some((k) => k in eb)) {
    ALLOWANCE_KEYS.forEach((k) => { v[k] = Number(eb[k] || 0); });
  } else {
    ALLOWANCE_KEYS.forEach((k) => { v[k] = 0; });
    v.other_allowance = Number(slip?.allowances || 0);
  }
  v.overtime = Number(slip?.overtime || 0);
  v.bonus = Number(slip?.bonus || 0);
  v.claims_reimbursement = Number(slip?.claims_reimbursement || 0);
  v.loan_deduction = Number(db.loan_deduction || 0);
  const ua = Number(db.unauthorised_absence_deduction || 0);
  v.other_deductions = 'other_deductions' in db
    ? Number(db.other_deductions || 0)
    : Math.max(0, Number(slip?.other_deductions || 0) - v.loan_deduction - ua);
  return v;
}

export const fmtRM = (n) => `RM ${Number(n || 0).toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
